<template>
  <div class="home">
    <Navigation />

    <section class="about-container">
      <div class="about" id="about">
        <h2 class="visuallyhidden">About Wire To Wire LLC</h2>

        <div class="image">
          <img src="img/wires.jpg" alt="Wires" />
        </div>

        <div class="text">
          <h1>
            Who We Are at
            <span style="display: block; color: var(--orange)"
              >Wire To Wire</span
            >
          </h1>
          <div class="page-break"></div>
          <p>
            We have 25 plus years of experience in the field of IT processing,
            General Contracting, and Infrastructure. We also have Network
            Engineering training, extensive Computer training in support
            environments. Along with that we also have High/Low voltage
            residential/commercial wiring training and experience.
          </p>

          <div id="inquire" class="button medium">inquire about a job</div>
        </div>
      </div>
    </section>

    <Gallery />

    <section class="work-container" id="work">
      <h2 class="visuallyhidden">Work</h2>

      <div class="work-picture" id="wpic1">
        <h3>General Contracting</h3>
        <p class="sub-heading">This is a sub heading of text and stuff</p>
      </div>

      <div class="work-picture" id="wpic2">
        <h3>Networking</h3>
        <p class="sub-heading">This is a sub heading of text and stuff</p>
      </div>
      <div class="work-picture" id="wpic3">
        <h3>Low Voltage Wiring</h3>
        <p class="sub-heading">This is a sub heading of text and stuff</p>
      </div>
      <div class="work-picture" id="wpic4">
        <h3>Telecomms/VOIP</h3>
        <p class="sub-heading">This is a sub heading of text and stuff</p>
      </div>
      <div class="work-picture" id="wpic5">
        <h3>CCTV &amp; Alarm Systems</h3>
        <p class="sub-heading">This is a sub heading of text and stuff</p>
      </div>
      <div class="work-picture" id="wpic6">
        <h3>Pro A/V &amp; Home Theater</h3>
        <p class="sub-heading">This is a sub heading of text and stuff</p>
      </div>
    </section>

    <section class="slogan-container">
      <div class="slogan">
        <h1>Getting it done right, from Wire to Wire.</h1>
      </div>
    </section>

    <section class="review-container">
      <h2 class="visuallyhidden">Reviews</h2>
      <div class="review" id="review">
        <div class="a-review">
          <img src="img/ron_smith.jpg" alt="Reviewer photo" />
          <h3>Ron Smith</h3>
          <div class="page-break centered"></div>
          <p>"Thank you for your patience. Great work!, Very professional."</p>
        </div>
        <div class="a-review">
          <img src="img/gerald_rogan.jpg" alt="Reviewer photo" />
          <h3>Gerald Rogan</h3>
          <div class="page-break centered"></div>
          <p>
            "An excellent technician. Arrived on time, conducted himself
            professionally, picked up extra items to complete job. Always with
            can do attitude."
          </p>
        </div>
        <div class="a-review">
          <img src="img/patty_baker.jpg" alt="Reviewer photo" />
          <h3>Patty Baker</h3>
          <div class="page-break centered"></div>
          <p>
            "Excellent Service! Provided full scope work at last minute (without
            a survey). Happy customer!"
          </p>
        </div>
        <br class="clear" />
      </div>
    </section>

    <Contact />

    <footer>
      <div class="inner-footer">
        <h2 class="visuallyhidden">Our footer</h2>
        <p>
          &copy; Copyright {{ year }} by <em>WireToWire LLC</em>. All Rights
          Reserved.
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
import Navigation from '@/components/Navigation.vue';
import Gallery from '@/components/Gallery.vue';
import Contact from '@/components/Contact.vue';

export default {
  name: 'home',
  components: {
    Navigation,
    Gallery,
    Contact,
  },
  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
  mounted() {
    /* eslint-disable no-undef */
    $('nav .nav-item a').click(() => {
      // Toggle Class
      $('.active').removeClass('active');
      $(this).closest('li').addClass('active');
      const theClass = $(this).attr('class');
      $(`.${theClass}`).parent('li').addClass('active');
      // Animate
      $('html, body')
        .stop()
        .animate(
          {
            scrollTop: $($(this).attr('href')).offset().top - 100,
          },
          400
        );
      return false;
    });
    $('.scrollTop a').scrollTop();
  },
};
</script>

<style lang="scss" scoped></style>
